import { EntityTypeOld } from "Store/interfaces/products";
import { isAuthenticated } from "./KeycloakWrapper";

export const CART_RESOURCE_ROOT = "/insurance/carts.v2";
export const OPEN_CART_RESOURCE_ROOT = "/open/insurance/carts.v2";

export const DOWNTIME_RESOURCE_ROOT = "/open/downtime/status/SSX2";

export const getResourceRoot = (): string =>
  isAuthenticated() ? CART_RESOURCE_ROOT : OPEN_CART_RESOURCE_ROOT;

export const ADVICE_RESOURCE_ROOT = "/insurance/advice/personalinsurance";
export const OPEN_ADVICE_RESOURCE_ROOT =
  "/open/insurance/advice/personalinsurance";
export const COLLECTIVE_ADVICE_RESOURCE_ROOT =
  "/insurance/advice/collectivepersonalinsurance";
export const OPEN_INDIVIDUAL_ADVICE_RESOURCE_ROOT =
  "/open/insurance/advice/individualpersonalinsurance";
export const OPEN_COLLECTIVE_ADVICE_RESOURCE_ROOT =
  "/open/insurance/advice/collectivepersonalinsurance";

export const isValidEntity = (
  entity: EntityTypeOld<unknown, unknown>,
): boolean => !!(entity.current && !entity.isLoading && !entity.error);
